import Header5 from 'elements/Header5';
import ds from 'designsystem';
import { media } from 'designsystem/index';

const Header = Header5.extend`
  margin: 0 0 ${ds.get('metrics.m')};
  
    ${media.tablet`
    margin: 0 0 ${ds.get('metrics.l')};
  `}
`;

export default Header;



// WEBPACK FOOTER //
// ./src/kentico-blocks/ArticleSlider/Header.jsx